<p-dialog
  [closable]="false"
  [draggable]="false"
  [modal]="true"
  [resizable]="false"
  [visible]="true"
>
  <ng-template #header>
    <header class="confirm-dialog m-t-5">
      <h4>Reason of decline</h4>
    </header>
    <a
      role="button"
      tabindex="0"
      aria-hidden="true"
      (click)="close()"
      class="p-dialog-titlebar-icon ui-dialog-titlebar-close"
    >
      <span class="pi pi-times"></span>
    </a>
  </ng-template>

  <div class="row">
    <div class="col-md-12">
      <p-select
        [appendTo]="'body'"
        [options]="reasonOfDeclineList"
        [(ngModel)]="reasonOfDecline"
        [filter]="false"
        filterBy="label, value"
      >
      </p-select>
    </div>
  </div>

  <div class="activity-footer">
    <button pButton (click)="decline()" type="submit">Decline</button>
    <button pButton severity="secondary" (click)="close()">Cancel</button>
  </div>
</p-dialog>
